export function sortArray<T extends Record<string, unknown>>(
  array: T[],
  keys: (keyof T)[],
  direction: "asc" | "desc" = "asc",
) {
  return array.sort((a, b) => {
    for (const key of keys) {
      if (a[key] !== b[key]) {
        return (direction === "asc" ? 1 : -1) * (a[key] - b[key]);
      }
    }
  });
}
